export const IdInstructions = () => {
    return (
        <div className="flex flex-col items-center p-10 gap-4 text-center">
            <h3>Απαιτήσεις ποιότητας εικόνας</h3>
            <div className="overflow-auto h-[80vh] flex items-center flex-col gap-4 scrollbar">
                <p className="text-body">
                Ακολουθούν οι απαιτήσεις για το μέγεθος και την ποιότητα των εικόνων εγγράφων που έχουν τραβηχτεί από
                οποιαδήποτε συσκευή, οι οποίες είναι απαραίτητες για την επιτυχή επεξεργασία εικόνων:
                </p>
                <h4>Καλός φωτισμός</h4>
                <p className="text-body">
                    Ο καλός φωτισμός βοηθά στην επίτευξη καλύτερων αποτελεσμάτων της Οπτικής Ανάγνωσης Χαρακτήρων (OCR). Εάν η
                    εικόνα είναι πολύ σκοτεινή ή πολύ φωτεινή, ενδέχεται να μην ολοκληρωθεί επιτυχώς η επεξεργασία του εγγράφου.
                </p>
                <img src="/avis/images/regula_samples/1.jpg" className="w-10/12"/>
                <h4>Αποφύγετε τις αντανακλάσεις</h4>
                <p className="text-body">
                    Οι έντονες αντανακλάσεις παρεμβαίνουν στην επεξεργασία και μειώνουν την ακρίβεια εξαγωγής δεδομένων. Συνιστούμε
                    να μην χρησιμοποιείτε το φλας της κινητής συσκευής σας κατά τη λήψη εικόνων εγγράφων.
                </p>
                <img src="/avis/images/regula_samples/2.jpg" className="w-10/12"/>
                <h4>Εστίαση και ευκρίνεια</h4>
                <p className="text-body">Βεβαιωθείτε ότι η εικόνα είναι καθαρή και ότι δεν υπάρχουν θολές περιοχές.</p>
                <img src="/avis/images/regula_samples/3.jpg" className="w-10/12"/>
                <h4>Γωνία</h4>
                <p className="text-body">
                    Η γωνία κλίσης του εγγράφου δεν πρέπει να υπερβαίνει τις 10 μοίρες προς οποιαδήποτε κατεύθυνση (οριζόντια ή
                    κατακόρυφη).
                </p>
                <img src="/avis/images/regula_samples/4.jpg" className="w-10/12"/>
                <h4>Περιθώρια (πολύ μικρά)</h4>
                <p className="text-body">
                    Βεβαιωθείτε ότι υπάρχει ελάχιστος χώρος γύρω από το έγγραφο. Συνιστάται το έγγραφο να καταλαμβάνει το 70-80% της
                    εικόνας.
                </p>
                <img src="/avis/images/regula_samples/5.jpg" className="w-10/12"/>
                <h4>Περιθώρια (πολύ μεγάλα)</h4>
            
                <p className="text-body">
                    Βεβαιωθείτε ότι ο χώρος γύρω από το έγγραφο δεν καταλαμβάνει περισσότερο από το 20-30% της εικόνας. Συνιστάται
                    το έγγραφο να καταλαμβάνει το 70-80% της εικόνας.
                </p>
                <img src="/avis/images/regula_samples/6.jpg" className="w-10/12"/>
                <h4>Αντίθεση</h4>

                <p className="text-body">
                    Το έγγραφο πρέπει να είναι σε σαφή αντίθεση με το φόντο. Ένα ανοιχτόχρωμο έγγραφο σε ανοιχτόχρωμο φόντο, καθώς
                    και ένα σκούρο έγγραφο σε σκούρο φόντο, ενδέχεται να μην αναγνωρίζεται.
                </p>
                <img src="/avis/images/regula_samples/7.jpg" className="w-10/12"/>
                <h4>Ανάλυση της εικόνας</h4>
            
                <p className="text-body">
                    Για την επίτευξη καλής ποιότητας αναγνώρισης εγγράφων αναγνώρισης, σας συνιστούμε να παρέχετε σε εικόνες που
                    έχουν τραβηχτεί από μια κάμερα με ανάλυση τουλάχιστον Full HD (1920 × 1080) και αυτόματη εστίαση. Τα αρχεία
                    εικόνας θα πρέπει να είναι από 1MB έως 8MB.
                </p>
                <img src="/avis/images/regula_samples/8.jpg" className="w-10/12"/>
                        <strong>Εξωγενή αντικείμενα</strong>

                <p className="text-body">
                    Βεβαιωθείτε ότι τα χέρια σας ή άλλα αντικείμενα δεν καλύπτουν δεδομένα εγγράφων.
                </p>
                <img src="/avis/images/regula_samples/9.jpg" className="w-10/12"/>
                <strong>Υποστηριζόμενοι τύποι αρχείων και γενικές οδηγίες</strong>
                <p className="text-body">
                    Βεβαιωθείτε ότι τα αρχεία που ανεβάζετε είναι της μορφής JPG, JPEG, PNG. Ακόμη, τα αρχεία δεν θα πρέπει να έχουν
                    υποστεί επεξεργασία ή enhancement ή αλλοίωσης χρώματος από photoshop ή άλλο πρόγραμμα επεξεργασίας φωτογραφιών.
                    Η μόνη αποδεκτή επεξεργασία από οποιοδήποτε πρόγραμμα επεξεργασίας φωτογραφιών είναι το cropping των περιθωρίων.
                </p>
            </div>
        </div>
    )
}